/**
 * AI Recruit - View Audit Trail Button Component
 * Button to open audit trail modal
 */

import React from 'react'
import { ClipboardDocumentListIcon } from '@heroicons/react/24/outline'
import Tooltip from '../common/Tooltip'

interface ViewAuditTrailButtonProps {
  onClick: () => void
}

const ViewAuditTrailButton: React.FC<ViewAuditTrailButtonProps> = ({ onClick }) => {
  return (
    // 'bottom', not 'top': this button sits inside a scrollable results list
    // (overflow-y-auto). A 'top' tooltip renders above the icon, which for
    // the first row has no room inside that scroll container and gets
    // clipped -- invisible even though it's technically showing. 'bottom'
    // always has room below.
    <Tooltip content="Audit Trail" position="bottom">
      <button
        onClick={onClick}
        className="inline-flex items-center justify-center w-6 h-6 rounded hover:bg-gray-100 transition-colors"
        aria-label="View audit trail"
      >
        <ClipboardDocumentListIcon className="w-4 h-4 text-gray-600 hover:text-blue-600" />
      </button>
    </Tooltip>
  )
}

export default ViewAuditTrailButton
